let dateTimeCount = {'year': 1, 'month': 2, 'day': 3, 'hour': 4, 'minute': 5, 'second': 6, 'millisecond': 7};
/**
 * 格式化数字（补0）
 *
 * @param     x       待格式化的数字
 * @param     y       结果的位数（默认为2）
 * @param     o       在数字前补0（默认为true，false为在数字后补0）
 * @return  String    格式化后的字符串
 */
function formatInt(x, y, o) {
  y = y && y > 0 ? y : 2;
  o = o === false || o === true ? o : true;
  let xArr = String(x).split(''), zCount = y - xArr.length > 0 ? y - xArr.length : 0;
  for (let i = 0; i < zCount; i++) {
    if (o === true) {
      xArr.unshift(0);
    } else {
      xArr.push(0);
    }
  }
  return xArr.join('');
}

//日期转为字符串
function dateToString(date, option) {
  let result = null, count = 6;
  if (date) {
    if (valueType(date, 'Number') === true) {
      date = new Date(date)
    }
    if (valueType(date, 'Date') === true) {
      if (valueType(option, 'String') === true) {
        if (option.startsWith('begin')) {
          count = parseInt(option.substr('begin'.length)) ? parseInt(option.substr('begin'.length)) : dateTimeCount[option.substr('begin'.length + 1)];
          date.setHours(0);
          date.setMinutes(0);
          date.setSeconds(0);
          date.setMilliseconds(0);
        } else if (option.startsWith('end')) {
          count = parseInt(option.substr('end'.length)) ? parseInt(option.substr('end'.length)) : dateTimeCount[option.substr('end'.length + 1)];
          date.setHours(23);
          date.setMinutes(59);
          date.setSeconds(59);
          date.setMilliseconds(999);
        } else {
          count = parseInt(option) ? parseInt(option) : dateTimeCount[option];
        }
      }
      if (valueType(option, 'Number') === true) {
        count = option;
      }
      let dateTimeArray = [String(date.getFullYear()), '-' + formatInt(date.getMonth() + 1), '-' + formatInt(date.getDate()),
        ' ' + formatInt(date.getHours()), ':' + formatInt(date.getMinutes()), ':' + formatInt(date.getSeconds()), '.' + formatInt(date.getMilliseconds(), 3)];
      result = '';
      // count = count ? (count > 7 ? 6 : count < 1 ? 6 : count) : 6;
      count = count && count <= 7 && count >= 1 ? count : 6;
      for (let i = 0; i < count; i++) {
        result += dateTimeArray[i];
      }
    }
  }
  return result;
}

//字符串转为日期
function stringToDate(str) {//str的格式为yyyy-MM-dd HH:mm:ss.msms或yyyy-MM-dd HH:mm:ss或yyyy-MM-dd或HH:mm:ss
  let date = new Date();
  if (str === 'today_begin') {
    return stringToDate(dateToString(date).substr(0, 10) + ' 00:00:00.000');
  }
  if (str === 'today_end') {
    return stringToDate(dateToString(date).substr(0, 10) + ' 23:59:59.999');
  }
  if (str === 'today') {
    return date;
  }
  if (!str || valueType(str, 'String') === false) {
    return null;
  }
  let year = date.getFullYear(), month = date.getMonth() + 1, day = date.getDate(),
    hour = date.getHours(), minute = date.getMinutes(), second = date.getSeconds(), millisecond = 0;
  if (str.length === 10) {
    year = str.substr(0, 4);
    month = str.substr(5, 7);
    day = str.substr(8, 10);
  }
  if (str.length === 8) {
    hour = str.substr(0, 2);
    minute = str.substr(3, 5);
    second = str.substr(6, 8);
  }
  if (str.length === 19) {
    year = str.substr(0, 4);
    month = str.substr(5, 7);
    day = str.substr(8, 10);
    hour = str.substr(11, 13);
    minute = str.substr(14, 16);
    second = str.substr(17, 19);
  }
  if (str.length === 23) {
    year = str.substr(0, 4);
    month = str.substr(5, 7);
    day = str.substr(8, 10);
    hour = str.substr(11, 13);
    minute = str.substr(14, 16);
    second = str.substr(17, 19);
    millisecond = str.substr(20, 23)
  }
  return new Date(parseInt(year), parseInt(month) - 1, parseInt(day), parseInt(hour), parseInt(minute), parseInt(second), parseInt(millisecond));
}

//某年某月最大天数
function lastday(year, month) {
  let d = new Date(parseInt(year), parseInt(month), 1, 0, 0, 0, 0);
  return new Date(d.getTime() - 1000).getDate();
}

//父路由名栈
function parentRouteStack(routeName, options) {
  let parentRoutes = [];
  toFindParentRoutes(routeName, options, parentRoutes);
  return parentRoutes;
}

function toFindParentRoutes(routeName, options, parentRoutes) {
  if (!options || options.length === 0) {
    return false;
  }
  for (let o of options) {
    let flag = toFindParentRoutes(routeName, o.children, parentRoutes);
    if (o.name === routeName || flag === true) {
      parentRoutes.push(o);
      return true;
    }
  }
}

//将列表中不足pageSize数的分页填充至pageSize数
function fillTheTable(columns, fillCount) {
  let fillList = [];
  if (fillCount > 0) {
    let ele = {emptyRow: true};
    for (let col of columns) {
      if (!col.render) {
        ele[col.key] = '';
      }
      else {
        console.log(valueType(col.render))
      }
    }
    for (let i = 0; i < fillCount; i++) {
      fillList.push(Object.assign({}, ele));
    }
  }
  return fillList;
}

/**
 * HSL颜色值转换为RGB.
 * 换算公式改编自 http://en.wikipedia.org/wiki/HSL_color_space.
 * h, s, 和 l 设定在 [0, 1] 之间
 * 返回的 r, g, 和 b 在 [0, 255]之间
 *
 * @param     h       色相
 * @param     s       饱和度
 * @param     l       亮度
 * @return  Array           RGB色值数值
 */
function hslToRgb(h, s, l) {
  var r, g, b;

  if (s == 0) {
    r = g = b = l; // achromatic
  } else {
    var hue2rgb = function hue2rgb(p, q, t) {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    };

    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }

  return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
}

/**
 * RGB 颜色值转换为 HSL.
 * 转换公式参考自 http://en.wikipedia.org/wiki/HSL_color_space.
 * r, g, 和 b 需要在 [0, 255] 范围内
 * 返回的 h, s, 和 l 在 [0, 1] 之间
 *
 * @param     r       红色色值
 * @param     g       绿色色值
 * @param     b       蓝色色值
 * @return  Array           HSL各值数组
 */
function rgbToHsl(r, g, b) {
  r /= 255, g /= 255, b /= 255;
  var max = Math.max(r, g, b), min = Math.min(r, g, b);
  var h, s, l = (max + min) / 2;

  if (max == min) {
    h = s = 0; // achromatic
  } else {
    var d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }

  return [h, s, l];
}

function generateColors(count, shuffle) {
  count = parseInt(count);
  if (isNaN(count)) {
    throw new Error("未指定生成颜色数量");
  }
  var step = parseInt(360 / count);
  var currentHue = 15 / 360, result = [];
  for (var i = 0; i < count; ++i) {
    var rgbArray = hslToRgb(currentHue, 1, 0.5);
    result.push("RGB(" + rgbArray[0] + "," + rgbArray[1] + "," + rgbArray[2] + ")");
    currentHue += step / 360;
  }
  if (!shuffle) {
    return result;
  } else {
    var shuffleResult = [];
    var cycle = count % 2 == 0 ? parseInt(count / 2) : parseInt(count / 2) + 1
    for (i = 0; i < cycle; ++i) {
      shuffleResult.push(result[i]);
      if (i + cycle < result.length) {
        shuffleResult.push(result[i + cycle]);
      }
    }
    return shuffleResult;
  }
}

//返回value的数据类型或判断value的类型是否等于type
function valueType(value, type) {
  let t = Object.prototype.toString.call(value), resultType = t.substr(8, t.length - 9);
  if (type) {
    return resultType === type;
  } else {
    return resultType;
  }
}

//是否在当前权限内，开发环境下可注释掉，生产环境下需解除注释
function permissionsFunction(value) {
  // let permissionList = JSON.parse(sessionStorage.getItem('currentUser')).permissionList.map((p) => {
  //   return p.permissionCode
  // });
  // value = value + "";
  // if (value.indexOf(',') < 0) {
  //   if (permissionList.indexOf(value) < 0) {
  //     return false;
  //   }
  // } else {
  //   let pArray = value.split(','), result = false;
  //   for (let p of pArray) {
  //     if (permissionList.indexOf(p) >= 0) {
  //       result = true;
  //     }
  //   }
  //   return result;
  // }
  // return true;
}

//保持树状结构的某个node在第二次点击时不被取消选择
function keepTreeNodeSelected(currentNode, nodeTree) {
  if (currentNode.sKey !== undefined) {
    for (let node of nodeTree) {
      if (node.sKey === currentNode.sKey) {
        node.selected = true;
      } else {
        delete node.selected;
      }
      if (node.children && node.children.length > 0) {
        keepTreeNodeSelected(currentNode, node.children);
      }
    }
  }
}

//两个对象的相等性（限于NaN，Null，Undefined，Number，String，Array，Object类型）
function equals(a, b) {
  let aType = valueType(a), bType = valueType(b), result = false;
  if (aType === bType) {
    if (["NaN", "Null", "Undefined"].indexOf(aType) >= 0) {
      result = true;
    } else if (["Number", "String", "Boolean"].indexOf(aType) >= 0) {
      result = a === b;
    } else if (["Array"].indexOf(aType) >= 0) {
      if (a.length === b.length) {
        result = true;
        if (a.length > 0) {
          for (let x of a) {
            if (b.indexOf(x) < 0) {
              result = false;
            }
          }
        }
      }
    } else if (["Object"].indexOf(aType) >= 0) {
      let aKeys = Object.keys(a), bKeys = Object.keys(b);
      if (equals(aKeys, bKeys) === true && aKeys.length > 0) {
        result = true;
        for (let k of aKeys) {
          if (equals(a[k], b[k]) === false) {
            //如果对象中有超出判断方法的类型限制的属性时，选择忽略跳过
            result = false;
          }
        }
      }
    } else {
      result = undefined;
    }
  }
  return result;
}
// 二维数组深拷贝
function deepcopy(obj) {
  var out = [],i = 0,len = obj.length;
  for (; i < len; i++) {
    if (obj[i] instanceof Array){
      out[i] = deepcopy(obj[i]);
    }
    else out[i] = obj[i];
  }
  return out;
}

// 判断字符串中是否有换行符
function judgeNewline(str) {
  let arr = '';
  if(str.indexOf('\n') > 0){
    arr = str.split('\n');
  }else {
    arr = str
  };
  return arr
}
//检查手机号
function isCellPhone(val) {
  // var phone = /^((0\d{2,3}-\d{7,8})|1(3|4|5|6|7|8|9)\d{9})$/;
  var phone = /^1(3|4|5|6|7|8|9)\d{9}$/;
  if(phone.test(val)) {
    return true;
  }else {
    return false;
  }
}
/**
 * 时间戳
 */
function dateFormat(data) {
  // 时间处理 主要根据当前时间的凌晨和当前时间周一的凌晨 做判断依据 （时间都转化成时间戳好计算，自认为）
  // var time = formatTime2(new Date());
  // let date = time.replace(/\//g, "-")
  // var date1 = new Date(date) // 现在的时间
  var lc = new Date(); // 当前时间的凌晨的时间戳
  var lb = new Date().setHours(0, 0, 0, 0);
  // console.log("当前时间的凌晨的时间戳 =>", lc)
  var nowlc = new Date(lc);
  var nowTime = nowlc.getTime();
  var day = nowlc.getDay();
  var oneDay = 24 * 60 * 60 * 1000;
  var Monday = nowTime - 7 * oneDay;
  var monday = new Date(Monday);
  var mondaytamp = Number(monday); //当前时间周一凌晨的时间戳
  // console.log("当前时间周一凌晨的时间戳 =>", mondaytamp)
  var date2 = new Date(data);
  var timetamp = data; // 转化成时间戳
  // console.log("后台获取的要处理的时间的时间戳 =>", timetamp)
  let d = ((lb - date2) / 1000); // 两个时间相差的秒数
  // console.log(d)
  if (d > 0) {
    var min = (d / 60).toFixed(0);
    var h = (min / 60).toFixed(0);
    // console.log(h)
    //   if (h <= 24) {
    //     data = "昨天"
    //   } else if (h <= 48) {
    //     data = "前天"
    //   } else if (h > 48) {
    let d = timetamp - mondaytamp;
    if (d >= 0) {
      var l = ["日", "一", "二", "三", "四", "五", "六"];
      let z = date2.getDay();
      data = "星期" + l[z];
      // if (z == 1) {
      // data = "周一"
      // } else if (z == 2) {
      // data = "周二"
      // } else if (z == 3) {
      // data = "周三"
      // } else if (z == 4) {
      // data = "周四"
      // } else if (z == 5) {
      // data = "周五"
      // } else if (z == 6) {
      // data = "周六"
      // } else if (z == 0) {
      // data = "周日"
      // }
    } else if (d < 0) {
      let y = date2.getFullYear();
      let m = date2.getMonth();
      let d = date2.getDate();
      data = y + "年" + (m + 1) + "月" + d + "日";
    }
    // }
  } else {
  // 当时时间段 时分
    let h = date2.getHours() < 10 ? '0'+ date2.getHours():date2.getHours();
    let m = date2.getMinutes() < 10 ?'0' + date2.getMinutes():date2.getMinutes();
    data = h + ":" + m
  }
  return data
}

export {dateToString}
export {parentRouteStack}
export {stringToDate}
export {lastday}
export {fillTheTable}
export {generateColors}
export {valueType}
export {permissionsFunction}
export {keepTreeNodeSelected}
export {equals}
export {deepcopy}
export {judgeNewline};
export {isCellPhone};
export {dateFormat};




// WEBPACK FOOTER //
// ./src/assets/js/reusableFunctions.js